import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { RouteDataService } from '@services/route-data/route-data.service';
import { EditPricingDialogContentComponent } from './edit-pricing-dialog-content/edit-pricing-dialog-content.component';

@Component({
  selector: 'app-edit-pricing-dialog',
  template: ''
})
export class EditPricingDialogComponent implements OnInit
{
  private modal: NgbModalRef | null = null
  private isOperatorView: string
  private pricingId: string
  private customerId: string
  
  constructor(
    public modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.isOperatorView = this.activatedRoute.parent.snapshot.data['isOperatorView'];
    this.pricingId = this.activatedRoute.snapshot.params.key;

    if (this.isOperatorView) {
      this.customerId = this.activatedRoute.parent.parent.snapshot.params.key;
    } else {
      this.customerId = this.activatedRoute.parent.snapshot.params.key;
    }
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    event.preventDefault();
    if (this.modal) this.modal.close()
  }

  ngAfterViewInit() {
    if (this.modalService.hasOpenModals()) return
    this.openDialog();
  }

  openDialog(): void {
    if (this.modal) {
      this.modal.close()
    }
    
    this.modal = this.modalService.open(
      EditPricingDialogContentComponent,
      { centered: true, size: 'xxl', backdrop: 'static' }
    )

    this.modal.componentInstance.customerId = this.customerId;
    this.modal.componentInstance.pricingId = this.pricingId;
    this.modal.componentInstance.isOperatorView = this.isOperatorView;

    this.modal.result.then(toDashboard => {
      if (toDashboard) window.history.go(-2)
      else this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
    }, (reason) => {
      this.router.navigate(['../../'], { relativeTo: this.activatedRoute })
    })
  }

  ngOnDestroy() {
    if (this.modal) {
      this.modal.close()
    }
  }
}
